// extracted by mini-css-extract-plugin
export default {"admin":"Admin_admin__fmxPQ","navbar":"Admin_navbar__LIVZD","content":"Admin_content__9mbbN"};